<template>
    <div class="flex pt-4 relative items-baseline flex-wrap md:flex-nowrap">
        <div class="mt-3 md:mr-4 mr-0 w-full md:w-5/12">
            <title-section class="ml-5 mb-4" :title="'Lista de envios'" @go-back="$emit('go-back')" />
            <div class="w-full md:w-auto md:overflow-y-auto pb-1 pr-0 md:pr-4 table md:block" style="height: calc(100vh - 320px)">
                <lot-item
                    v-for="payment in payments.payments"
                    class="mb-4"
                    :key="payment.id"
                    :lot="payment"
                    :is-section-details="false"
                />
            </div>
        </div>
        <div class="bg-white pl-7 pr-6 pt-4 pb-7 mb-8 md:mb-0 flex shadow-card rounded md:w-7/12 w-full md:justify-start justify-between">
            <div class="w-56 mr-8">
                <h3 class="font-medium">Resumo</h3>
                <div class="mt-5">
                    <span class="block text-xs text-gray-500 ">Quantidade de favorecidos diferentes</span>
                    <span class="block text-xs leading-6">3</span>
                </div>
                <div class="mt-4">
                    <span class="block text-xs text-gray-500">Quantidade de envios</span>
                    <span class="block text-xs leading-6">3</span>
                </div>
                <div class="mt-4">
                    <span class="block text-xs text-gray-500">Período de agendamento</span>
                    <span class="block text-xs leading-6">21/09/2022(Amanhã)</span>
                </div>
                <div class="mt-4">
                    <span class="block text-xs text-gray-500">Total a ser enviado</span>
                    <span class="block text-xs font-bold leading-6">R$ <span class="text-xl">{{ payments.total }}</span> </span>
                </div>
            </div>
            <div class="self-end">
                <div>
                    <div class="text-xs text-center">Código de autorização</div>
                    <jet-input
                        id="google_code"
                        type="number"
                        class="mt-1 block w-full text-md"
                        v-model="form.google_code"
                    />
                    <jet-input-error :message="form.error('google_code')" class="mt-1" />
                </div>
                <button
                    class="bg-green-500 text-white leading-none py-3 rounded w-full mt-3 text-xs hover:bg-green-600"
                    @click="transfer"
                >
                    Concluir transferência
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import LotItem from '../../components/LotItem.vue'
import TitleSection from '../../components/TitleSection.vue'
import JetInput from "../../../../Jetstream/Input.vue";
import JetInputError from "../../../../Jetstream/InputError.vue";

export default {
    name: 'ValueDetails',
    props: {
        payments: { type: Object, default: () => ({}) },
    },
    data(){
        return {
            form: this.$inertia.form({
                google_code: null,
                payments: this.payments
            })
        }
    },
    methods: {
        transfer(){
            if(!this.form.google_code){
                this.$toast.open({
                    message: 'Informe o código de autorização.',
                    type: 'error',
                    duration: 4000,
                    position: 'top-right'
                });
            }
        }
    },
    components: {
        LotItem,
        TitleSection,
        JetInput,
        JetInputError
    },
}
</script>
